import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel('2069000673664574');
  }, []);
  return <LandingPage data-id="element-0" />;
}